export default function page() {
	
  $('.event-container').imagesLoaded(function(){
    $('.page-container').css('min-height', $(window).height() - $('#header').outerHeight() - $('#footer').outerHeight());
  });
  
}